import { render } from "./MenuManager.vue?vue&type=template&id=9de7e3a4"
import script from "./MenuManager.vue?vue&type=script&lang=js"
export * from "./MenuManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__